export const UI_1_4_tableRow1 = [
  [
    {
      cellName: "데이터명",
      id: "korean_name",
      row: 1,
      col: 1,
    },
    {
      cellName: "활용 데이터 종류",
      id: "variable_name",
      row: 1,
      col: 1,
    },
    {
      cellName: "변수구분",
      id: "variable_id",
      row: 1,
      col: 1,
    },
    {
      cellName: "설명",
      id: "description",
      row: 1,
      col: 1,
    }
  ]
];


export const UI_1_4_tableRow2 = [
  [
    {
      cellName: "날짜",
      id: "date",
      row: 1,
      col: 1,
    },
    {
      cellName: "에너지종류",
      id: "energy",
      row: 1,
      col: 1,
    },
    {
      cellName: "사용/공급",
      id: "method",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "unit",
      row: 1,
      col: 1,
    },
    {
      cellName: "산업단지명",
      id: "complexName",
      row: 1,
      col: 1,
    },
    {
      cellName: "회사명",
      id: "companyName",
      row: 1,
      col: 1,
    },
    {
      cellName: "사업장명",
      id: "plantName",
      row: 1,
      col: 1,
    },
    {
      cellName: "변수명",
      id: "variableName",
      row: 1,
      col: 1,
    },
    {
      cellName: "변수값",
      id: "variableValue",
      row: 1,
      col: 1,
    },
  ]
];



export const UI_1_4_gridData1 = [
  
  {
    "variable_name": "current_total_usage",
    "korean_name": "15분 후 압축사용량",
    "variable_id": "Y1",
    "description": "t+t+15분 후 사용량"
  },
  {
    "variable_name": "prev_total_usage",
    "korean_name": "직전 15분간 사용량",
    "variable_id": "X1",
    "description": "t-t-15분 전 사용량"
  },
  {
    "variable_name": "lag1",
    "korean_name": "지연 값 lag",
    "variable_id": "X2",
    "description": "15분 간격 지연 값"
  },
  {
    "variable_name": "lag4",
    "korean_name": "지연 값 lag",
    "variable_id": "X3",
    "description": "15분 간격 기준 lag4 값"
  },
  {
    "variable_name": "lag96",
    "korean_name": "지연 값 lag",
    "variable_id": "X4",
    "description": "15분 간격 기준 lag96 지연 값"
  },
  {
    "variable_name": "lag672",
    "korean_name": "지연 값 lag",
    "variable_id": "X5",
    "description": "15분 간격 기준 lag672 지연 값"
  },
  {
    "variable_name": "std4",
    "korean_name": "롤링 통계 (4틱=1시간)",
    "variable_id": "X6",
    "description": "이동 통계 값"
  },
  {
    "variable_name": "mean4",
    "korean_name": "롤링 통계 (4틱=1시간)",
    "variable_id": "X7",
    "description": "이동 통계 값"
  },
  {
    "variable_name": "std24",
    "korean_name": "롤링 통계 (24틱=6시간)",
    "variable_id": "X10",
    "description": "이동 통계 값"
  },
  {
    "variable_name": "mean24",
    "korean_name": "롤링 통계 (24틱=6시간)",
    "variable_id": "X11",
    "description": "이동 통계 값"
  },
  {
    "variable_name": "std96",
    "korean_name": "롤링 통계 (96틱=24시간)",
    "variable_id": "X12",
    "description": "이동 통계 값"
  },
  {
    "variable_name": "mean96",
    "korean_name": "롤링 통계 (96틱=24시간)",
    "variable_id": "X13",
    "description": "이동 통계 값"
  },
  {
    "variable_name": "hour",
    "korean_name": "달력/주기",
    "variable_id": "X14",
    "description": "시 0 ~ 23"
  },
  {
    "variable_name": "minute",
    "korean_name": "달력/주기",
    "variable_id": "X15",
    "description": "분 0, 15, 30, 45"
  },
  {
    "variable_name": "dow",
    "korean_name": "달력/주기 (요일)",
    "variable_id": "X16",
    "description": "요일 0 ~ 6 (월:0)"
  },
  {
    "variable_name": "is_weekend",
    "korean_name": "달력/주기 (주말여부)",
    "variable_id": "X17",
    "description": "주말 여부 (토/일=1)"
  },
  {
    "variable_name": "dow_sin",
    "korean_name": "주기 (요일)",
    "variable_id": "X18",
    "description": "주기적 인코딩 값 (사인/코사인)"
  },
  {
    "variable_name": "dow_cos",
    "korean_name": "주기 (요일)",
    "variable_id": "X19",
    "description": "주기적 인코딩 값 (사인/코사인)"
  },
  {
    "variable_name": "hour_sin",
    "korean_name": "주기 (시간)",
    "variable_id": "X20",
    "description": "주기적 인코딩 값 (사인/코사인)"
  },
  {
    "variable_name": "hour_cos",
    "korean_name": "주기 (시간)",
    "variable_id": "X21",
    "description": "원형 변수의 경계 값 (예: 23시 <-> 0시)에서 거리 왜곡을 제거하여 모델 학습 안정화를 위해 사용"
  },
  {
    "variable_name": "usage_1min_ago",
    "korean_name": "분 단위 사용량",
    "variable_id": "X22",
    "description": "1분 전 사용량"
  },
  {
    "variable_name": "usage_3min_ago",
    "korean_name": "분 단위 사용량",
    "variable_id": "X23",
    "description": "3분 전 사용량"
  },
  {
    "variable_name": "usage_5min_ago",
    "korean_name": "분 단위 사용량",
    "variable_id": "X24",
    "description": "5분 전 사용량"
  },
  {
    "variable_name": "usage_7min_ago",
    "korean_name": "분 단위 사용량",
    "variable_id": "X25",
    "description": "7분 전 사용량"
  },
  {
    "variable_name": "usage_10min_ago",
    "korean_name": "분 단위 사용량",
    "variable_id": "X26",
    "description": "10분 전 사용량"
  },
  {
    "variable_name": "usage_5min_ago_15min",
    "korean_name": "15분 단위 사용량",
    "variable_id": "X27",
    "description": "해당 시점 기준 5분 롤링 합"
  },
  {
    "variable_name": "usage_10min_ago_15min",
    "korean_name": "15분 단위 사용량",
    "variable_id": "X28",
    "description": "5분/10분 전 조회 값"
  },
  {
    "variable_name": "is_active",
    "korean_name": "공장 가동 유무",
    "variable_id": "X29",
    "description": "공장 가동 유무 1 또는 0"
  },
  {
    "variable_name": "force_zero",
    "korean_name": "에너지 사용량 규모",
    "variable_id": "X30",
    "description": "강제 에너지 사용량 0 확인"
  }

];


export const UI_1_4_gridData2 = [
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "TON",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    variableName: "제품생산량",
    variableValue: "0"
  },
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "TON",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    variableName: "제품생산량",
    variableValue: "0"
  },
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "TON",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    variableName: "제품생산량",
    variableValue: "92"
  },
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "TON",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    variableName: "제품생산량",
    variableValue: "90"
  },
]